import { render } from "./EchartsColumnar.vue?vue&type=template&id=2e255d82"
import script from "./EchartsColumnar.vue?vue&type=script&lang=js"
export * from "./EchartsColumnar.vue?vue&type=script&lang=js"

import exportComponent from "/data/jenkins/workspace/vas-web-client-pre/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])